import React from 'react';
import { connect } from 'react-redux';
import { ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import Helmet from 'react-helmet';

import SecurityBoxLogo from '../SecurityBoxLogo';
import SecurityBoxInput from '../SecurityBoxInput';
import LoginSecurityBoxControls from './LoginSecurityBoxControls';
import SecurityBoxCommonError from '../SecurityBoxCommonError';
import SecurityDefaultForm from '../SecurityDefaultForm';
import Loading from '../Loading';
import { syncValidation } from '../../utils/loginValidator';
import * as login from '../../action-creators/login';
import * as user from '../../action-creators/user';
import * as service from '../../action-creators/services';

const PurchaseLogin = translate(['ui'])(
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: false,
        error: ''
      };
      this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillMount() {
      const { getCurrentUser } = this.props;
      getCurrentUser();
    }

    async onSubmit({ email, password, name }) {
      const {
        // eslint-disable-next-line no-shadow
        login,
        gaSend,
        match: {
          params: { tokenLink, partnerToken }
        }
      } = this.props; // eslint-disable-line
      this.setState({ loading: true });

      const res = await login(email.trim(), password, name, { tokenLink, partnerToken });
      const data = await res.json();
      if (res.ok) {
        gaSend({ category: 'Common', action: 'login_success', label: email });
        window.location = `${process.env.UNICAT_DEFAULT_SERVICE}/requests/all`;
      } else {
        this.setState({ loading: false, error: data.errors.code });
      }
    }

    render() {
      const { t, handleSubmit } = this.props;
      const { loading, error } = this.state;

      if (loading) {
        return <Loading text="Login to the system Please wait" />;
      }

      return (
        <div className="basic-container">
          <Helmet title={t('acc_login_title')} meta={[{ name: 'description', content: t('acc_login_description') }]} />
          <SecurityBoxLogo />
          <SecurityDefaultForm>
            <div className="default-right-form">
              <Form onSubmit={handleSubmit(this.onSubmit)}>
                <ControlLabel
                  style={{ fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 67, marginLeft: 50 }}
                >
                  {`${t('Login')} `}
                </ControlLabel>
                <FormGroup className="form-group-login">
                  <ControlLabel className="control-label-login">{t('E-mail')}</ControlLabel>
                  <Field name="email" type="text" component={SecurityBoxInput} placeholder={t('enter email')} />
                </FormGroup>
                {/* anitbot field */}
                <FormGroup className="form-group-login special-antibot-input">
                  <ControlLabel className="control-label-login">{t('name')}</ControlLabel>
                  <Field
                    name="name"
                    component={SecurityBoxInput}
                    input={{ tabIndex: '-1' }}
                    type="text"
                    placeholder={t('enter name')}
                  />
                </FormGroup>
                <FormGroup className="form-group-login" style={{ marginTop: 0 }}>
                  <ControlLabel className="control-label-login">{t('Password')}</ControlLabel>
                  <Field
                    name="password"
                    component={SecurityBoxInput}
                    marginTop="true"
                    type="password"
                    placeholder={t('enter password')}
                  />
                </FormGroup>

                <LoginSecurityBoxControls
                  forgotPassText={t('Forgot password')}
                  linkText={t('Register')}
                  submitText={t('Enter')}
                  registrationLink="/purchase/registration"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...this.props}
                />
                {error && <SecurityBoxCommonError error={t(error)} />}
                {!error && (
                  <div className="mobile-version">
                    <a
                      href={`${process.env.UNICAT_ACCOUNTS_SERVICE_MOBILE}/login?view=mobile`}
                      style={{ color: '#1C50DE' }}
                    >
                      {t('mobile_version')}
                    </a>
                  </div>
                )}
              </Form>
            </div>
          </SecurityDefaultForm>
        </div>
      );
    }
  }
);

const mapState = () => ({});

const PurchaseLoginForm = reduxForm({
  form: 'login',
  validate: syncValidation
})(PurchaseLogin);

export default connect(mapState, dispatch =>
  bindActionCreators(
    {
      login: login.login,
      gaSend: service.gaSend,
      getCurrentUser: user.getCurrentUser
    },
    dispatch
  )
)(PurchaseLoginForm);



// WEBPACK FOOTER //
// ./components/login/PurchaseLoginContainer.jsx